import { createFileRoute } from '@tanstack/react-router'

import {
  DASHBOARD_TABS,
  StaffDashboard,
  type DashboardTab,
} from '@/components/Internal/Dashboard/StaffDashboard'

export const Route = createFileRoute('/internal/dashboard')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { tab?: DashboardTab } => ({
    tab: DASHBOARD_TABS.find(tab => tab === search.tab),
  }),
  component: DashboardScreen,
})

function DashboardScreen() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <StaffDashboard
      tab={tab}
      onTabChange={next =>
        void navigate({ search: { tab: next }, replace: true })
      }
    />
  )
}
